module.exports = __webpack_public_path__ + "img/2.ba69f1a5.png";